export default "../css/fcd4310affaf30346b67289e9bfa9c98.ttf";